var _g, _g2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitur1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_462_20725)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 60,
    fill: "#D0D1D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_462_20725)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 55,
    stroke: "#D0D1D3",
    strokeWidth: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 60,
    height: 61,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_20725",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_462_20725",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_462_20725",
    transform: "translate(0 0.00819672) scale(0.0111111 0.010929)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_462_20725",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACC0lEQVR4nO3dS0oDQRSF4WNwoqK4C1chuBhX5AMyztAd6MhluAoVlAwTB2rQkPaRvnX63uT/oCah6eo6lGXXTUEkAAAAANhi+5KuJT1LmidrT5KuJO01G73RWMMH+lsbNxv9h53G9x9JelX+GTOVdChp1qqDUasb47vWQc8kTRr3EWGihrPZZU/Spd7/8Qy9Fi+3R0kXyr+0AQAAmGSuY0S1FPWQCnWMqNarHtKn1lGljhGlVz2EWodJn6Cr1DGiDFoPyVzHiGoh9ZDIevQ88F6ZhGTEGm1C0Ca7hj66/vS6lpps14dgRpsQtAlBmxC0CUGbsGH5HRuWSgi6oJaFnVtJ55JOJB24BpRVi4AfJJ06B1FBdMj3ko6tIyiiK7D/Xv85kwm5Q2TQZ02ftLiooO/aPuYwMr7e3XR8XvEMSZMzIVEz+qTj+spnSMaOLfh/C+1Hkl6WPqt+hmTq+Iblp1m9ynLIGyHjGr1K9TMkoc8etZ51qXiGZHEmJGOZ9C/PFNVXa4uxVFk6yiNok4znOpx92c6EMKNNCNqEoE0I2oSgTTJuWL4a5ORnIDYsbgRtQtAmBG1C0CYZax193oSodWw7gjYhaBOCNiFok4y1Dr6cxfoI2oSgTQjahKBNHLUOJ2od246gTSKXjta/gFEaM9qEoE027a2jdQ1k7fszo00I2oSgTQjahKBN3gD8aWUwNjqb+gAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur1);
export default __webpack_public_path__ + "static/media/fitur1.81273701c97bbeddaa830f65e3037859.svg";
export { ForwardRef as ReactComponent };